import React from 'react'
import LevelInstructionsCard from './levelInstructionsCard'
import LevelCard from './levelCard'
import useMediaQuery from 'hec/hooks/useMediaQuery'
import PropTypes from 'prop-types'

import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselPrevious,
    CarouselNext,
    ContentButtonNavigation,
    navButtonTypes
} from '@/components/ui/carousel'

export const LevelCards = ({levels, enrollment, sfccLearningCenterData}) => {
    const isMobile = useMediaQuery('sm')
    return (
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-4 m-auto">
            {isMobile ? (
                <Carousel opts={{loop: true}} data-testid="levelCards-Carousel">
                    <CarouselPrevious
                        overlapContent={false}
                        fillColor="#FFFFFF"
                        iconAttributes={{className: 'h-6 w-6'}}
                        data-testid="levelCards-CarouselPrevious"
                    />
                    <CarouselContent className="mx-auto" data-testid="levelCards-CarouselContent">
                        {levels &&
                            levels?.map((level, index) => {
                                return (
                                    <CarouselItem key={index} data-testid="levelCards-CarouselItem">
                                        <LevelCard
                                            key={index}
                                            index={index}
                                            level={level}
                                            enrollment={enrollment}
                                            sfccLearningCenterData={sfccLearningCenterData}
                                            data-testid="levelCards-LevelCard"
                                        />
                                    </CarouselItem>
                                )
                            })}
                        <CarouselItem data-testid="levelCards-CarouselItem">
                            <LevelInstructionsCard data-testid="levelCards-LevelInstructionsCard" />
                        </CarouselItem>
                    </CarouselContent>
                    <CarouselNext
                        overlapContent={false}
                        fillColor="#FFFFFF"
                        iconAttributes={{className: 'h-6 w-6'}}
                        data-testid="levelCards-CarouselNext"
                    />
                    <ContentButtonNavigation
                        buttonType={navButtonTypes.FlatButton}
                        data-testid="levelCards-ContentButtonNavigation"
                    />
                </Carousel>
            ) : (
                <>
                    <LevelInstructionsCard data-testid="levelCards-LevelInstructionsCard" />
                    {levels &&
                        levels?.map((level, index) => {
                            return (
                                <LevelCard
                                    key={index}
                                    index={index}
                                    level={level}
                                    enrollment={enrollment}
                                    sfccLearningCenterData={sfccLearningCenterData}
                                    data-testid="levelCards-LevelCard"
                                />
                            )
                        })}
                </>
            )}
        </div>
    )
}

LevelCards.propTypes = {
    levels: PropTypes.array,
    enrollment: PropTypes.object,
    sfccLearningCenterData: PropTypes.object
}

export default LevelCards
